import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "loading"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_loader = _resolveComponent("dw-loader")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["dw-button", _ctx.dwButtonClasses]),
    disabled: _ctx.disabled,
    loading: _ctx.loading,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_dw_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}